import {addOption,enumDevice,getUserList,verifyUserPin,getVersion,getFiles,ReadFileValue} from './mTokenBasicOper';
import {mToken,mTokenPlugin} from './mToken';
var token = new mToken("mTokenPlugin");
// function getUkeyObject(userKeyPassword){
//     var ret;
//     var strDeviceName;
//     var fileList;
//     var retError;

//     ret = enumDevice();
//     if (checkError(ret))
//     {
//         strDeviceName = ret;
//         ret = getUserList(strDeviceName);
//         if (checkError(ret))
//         {
//             ret = verifyUserPin(userKeyPassword);
//             if (checkError(ret))
//             {
//                 var fileList = getFiles();
//                 ret = ReadFileValue(fileList[0]);
//                 // alert(strDeviceName + ":" + ret.substring(0,36));
//                 // return strDeviceName + ":" + ret;
//                 var content = ret.substring(0,36);
//                 return strDeviceName + ":" + content;
//             }
//         }
//     }
//     // alert(ret);
//     return ret;
// }


//刘
function getUkeyObject(userKeyPassword)
{
    var ret;
    var strDeviceName;
    var fileList;
    var retError;
    var res = {};

    ret = enumDevice();
    if (ret.num == 1001)
    {   
        var oldNum = ret.num;
        strDeviceName = ret.msg;
        ret = getUserList(strDeviceName);
        if (checkError(ret))
        {
            ret = verifyUserPin(userKeyPassword);
            if (checkError(ret))
            {
                var fileList = getFiles();
                ret = ReadFileValue(fileList[0]);
                res.msg = "验证成功";
                res.info = strDeviceName[0] + ":" + ret.substring(0,36);
                res.num = oldNum;
                
                return res;
            }
        }
    }else if(ret.num == 1002){
        //下载 ukey
        // alert(ret.msg);
    }else if(ret.num == 1003){
        //未找到 key
        // alert(ret.msg);
    }
    return ret;
}

/**
 * 获取设备剩余输错的次数
 * @error 184550433---0x0B000421---没发现应用
 */
function getRetryCount()
{
    //1、加载智能卡中间件
    token.SOF_LoadLibrary(token.GM3000);
    //2、查找查找设备
    var deviceListArr = token.SOF_EnumDevice();         //获取设备列表 --- 初始化一次之后，一直都可以使用  返回结果：["0D7B7CEE2149F0A0A22EBAA54DAA2C1"]
    //2.1、如果没有对应的设备，则返回NULL
    if(deviceListArr == null)
    {

        return funcRet(1003, "", "未检测到设备！");
    }
    //2.2、获取设备列表长度
    // var deviceLength = deviceListArr.length;
    // for(var i=0;i<deviceLength;i++)
    // {
    //     //2.3、监测设备
    //     token.SOF_GetDeviceInstance(deviceListArr[i], "");        //获取设备实例 --- 初始化一次之后，一直都可以使用  初始化实例，实例化后才可以获取对应的实例数据
    //     //2.4、获取剩余输入错误次数
    //     var retryCount = token.SOF_GetPinRetryCount();             //设备剩余重试次数
    // }

    //3、监测设备
    token.SOF_GetDeviceInstance(deviceListArr[0], "");        //获取设备实例 --- 初始化一次之后，一直都可以使用  初始化实例，实例化后才可以获取对应的实例数据

    //4、获取剩余输入错误次数
    var retryCount = token.SOF_GetPinRetryCount();             //设备剩余重试次数

    return funcRet(1001, retryCount);

}
function funcRet(num, info, msg)
{

    var result = {};
    result.msg = msg || "";       //文字说明
    result.info = info;     //返回的信息
    result.num = num;       //代码编号
    return result;

}

function checkError(retMessage)
{
    if (retMessage.indexOf("error") == -1) 
        return true;
    else
        return false;
}

function getError(retMessage) {
    var arr = retMessage.split(":");
    return arr[1];
}

//张
/**
 * 验证U-Key的统一性：安全码的验证；
 * @param userKeyPassword
 * @returns {*}
 */
// function getUkeyObject(userKeyPassword)
// {
//     var ret;
//     var strDeviceName;
//     var fileList;
//     var res = {};

//     ret = enumDevice();
//     if (ret.num == 1001)
//     {
//         var oldNum = ret.num;
//         strDeviceName = ret.msg;
//         ret = getUserList(strDeviceName);
//         if (checkError(ret))
//         {
//             ret = verifyUserPin(userKeyPassword);
//             if (checkError(ret))
//             {
//                 var fileList = getFiles();
//                 ret = ReadFileValue(fileList[0]);
//                 res.msg = "验证成功";
//                 res.info = strDeviceName[0] + ":" + ret.substring(0,36);
//                 res.num = oldNum;
//                 return res;
//             }
//         }
//     }
//     res.num = 1002;
//     res.msg = "设备验证失败！";
//     return res;
// }

// /**
//  * 监测是否存在U-Key设备；监测是否正常加载插件；
//  * @returns {{}}
//  */
// function checkUkeyDevice()
// {

//     var deviceStatus = {};
//     var ret = enumDevice();
//     if(ret.num == 1002){
//         return ret;
//     }else if(ret.num == 1003){
//         return ret;
//     }
//     deviceStatus.num = 1001;
//     deviceStatus.msg = "设备验证成功！";
//     return deviceStatus;

// }

// function checkError(retMessage)
// {
//     if (retMessage.indexOf("error") == -1) 
//         return true;
//     else
//         return false;
// }

// function getError(retMessage) {
//     var arr = retMessage.split(":");
//     return arr[1];
// }
export {
    getUkeyObject,
    checkError,
    getError,
    getRetryCount
    
}


// WEBPACK FOOTER //
// ./src/page/login/Ukey/mToken_System.js